import System from '@/store/index'

const fetchOnlyQuestionsUrl= '/api/office/laws/lawVersion'
// 获取题目
export const fetchLawVersion  = () => {
  return System.user.get(fetchOnlyQuestionsUrl).then((res)=>{
    if (res.status==200) {
      return res.data
    }else{
      return Date.now()
    }
  })
  .catch((error)=>{
    console.log('error',error)
  })
}

